{
  "title": "地雷",
  "subtitle": "避開地雷，安全格越多倍率越高",
  "connecting": "連線中…",
  "connected": "已連線",
  "reconnecting": "重連中…",
  "unauthorized": "未授權",
  "authFailed": "登入失敗",
  "retryLogin": "重試連線",
  "backLobby": "回大廳",
  "lobby": "大廳",
  "balance": "餘額 {{amount}}",
  "bet": "下注金額",
  "mineCount": "地雷數",
  "half": "1/2",
  "max": "全下",
  "quickChips": "快速籌碼",
  "close": "關閉",
  "start": "開始探險",
  "restoringRound": "正在確認進行中的局…",
  "restoreFailed": "無法確認目前局況，為避免重複下注已暫停操作",
  "actionOutcomeUnknown": "這次操作結果尚未確認；請先重新同步目前局況，再繼續遊戲",
  "restoreBalanceFailed": "已確認沒有進行中的局，但餘額更新失敗；請再次同步局況",
  "retryRestore": "重新確認局況",
  "balanceRefreshFailed": "操作已完成，餘額暫時無法更新",
  "retryBalance": "重新整理餘額",
  "refreshingBalance": "正在更新餘額…",
  "multiplier": "倍率",
  "nextCell": "下一格",
  "opened": "已開",
  "roundSummary": "{{mines}} 個地雷 · 已開 {{opened}} 個安全格",
  "cashout": "出場結算 {{amount}}",
  "cashedHint": "出場成功 · 倍率 {{mult}}x · 派彩 {{payout}}",
  "bombed": "踩到地雷，本局結束（圖上已顯示全部雷位）",
  "again": "再來一局",
  "rules": "遊戲規則",
  "rulesTitle": "地雷 (Mines) 遊戲規則",
  "rulesBody": "在 5×5 的 25 格地圖中，隨機隱藏著指定數量的地雷。每開啟一個安全水晶，獲利倍率就會遞增。您可以隨時點擊「出場結算」獲利了結；若踩到地雷則失去本局所有下注。",
  "cellHidden": "格子 {{n}}",
  "cellMine": "地雷 {{n}}",
  "cellSafe": "安全 {{n}}",
  "startFailed": "開始失敗",
  "openFailed": "開格失敗",
  "cashFailed": "出場失敗",
  "errors": {
    "insufficient_funds": "餘額不足",
    "user_not_found": "找不到使用者",
    "no_active_round": "尚無進行中的局",
    "round_ended": "本局已結束",
    "cell_opened": "此格已開啟",
    "open_safe_first": "請先開啟至少一格安全格",
    "busy": "尚有動作進行中",
    "invalid_bet": "下注金額無效",
    "invalid_mines": "地雷數無效",
    "invalid_cell": "格子無效",
    "unauthorized": "請先登入",
    "unknown": "發生錯誤"
  }
}
